export const TRACK_EVENT = 'TRACK_EVENT';

export const trackEvent = (name, bookingID, userID, data) => {
  return {
    type: TRACK_EVENT,
    payload: {
      name: name,
      booking: bookingID,
      user_id: userID,
      data: data,
    },
  };
};



// WEBPACK FOOTER //
// ./src/actions/analytics/index.js